import type { TourStep } from "./types";

export const TOUR_STEPS: TourStep[] = [
  {
    id: "welcome",
    target: null,
    title: "Bienvenue dans Systeme1-immo",
    description:
      "Le premier outil immobilier qui combine neurosciences, IA et prospection terrain. En quelques minutes, vous allez voir comment transformer chaque contact en opportunité concrète.",
    placement: "center",
    ctaLabel: "C'est parti",
  },
  {
    id: "juliette",
    target: null,
    title: "Juliette, votre copilote",
    description:
      "Au cœur de Systeme1-immo, il y a Juliette : votre assistante immobilière propulsée par l'IA. Son halo lumineux reste à portée de main dans la barre, sur ordinateur comme sur mobile — un clic, et vous lui parlez à l'écrit ou à la voix. On vous présente tout ce qu'elle sait faire à la fin de cette visite.",
    placement: "center",
  },
  {
    id: "new-lead-btn",
    target: '[data-tour-step="new-lead-btn"]',
    title: "Créer un contact rapidement",
    description:
      "Ajoutez un prospect en quelques secondes depuis n'importe quelle page. Coordonnées, source, contexte : tout rejoint votre CRM pour ne laisser aucun contact se perdre.",
    placement: "right",
    navigateTo: "/",
  },
  {
    id: "dashboard-kpis",
    target: '[data-tour-step="dashboard-kpis"]',
    title: "Vos priorités du jour",
    description:
      "Leads chauds, rendez-vous, relances et mandats : vos indicateurs clés sont réunis ici. Juliette y met en avant ce qui mérite votre attention — cliquez une carte pour filer droit vers les contacts à traiter.",
    placement: "bottom",
  },
  {
    id: "dashboard-action-queue",
    target: '[data-tour-step="dashboard-action-queue"]',
    title: "Commencer par les bonnes actions",
    description:
      "Chaque matin, Juliette prépare votre briefing : messages non lus, signaux à traiter, leads chauds et relances à lancer. Vous savez en un coup d'œil par quoi commencer.",
    placement: "top",
  },
  {
    id: "sidebar-prospection",
    target: '[data-tour-step="nav-prospection"]',
    title: "Carnet Terrain",
    description:
      "Rendez votre prospection terrain dix fois plus efficace. En face d'un prospect, vous pouvez créer sa fiche et lui envoyer immédiatement les bons documents par WhatsApp ou email.",
    placement: "right",
  },
  {
    id: "sidebar-media",
    target: '[data-tour-step="nav-media"]',
    title: "Votre bibliothèque commerciale",
    description:
      "Stockez ici tous les supports que vous voulez partager : vidéos, plaquettes, flyers, modèles d'offre d'achat, PDF ou documents agence. Ils pourront ensuite être envoyés depuis le Carnet Terrain ou la messagerie.",
    placement: "right",
  },
  {
    id: "sidebar-crm",
    target: '[data-tour-step="nav-crm"]',
    title: "CRM unifié",
    description:
      "Retrouvez tous vos contacts au même endroit : terrain, import, annonces, site web ou recommandations. Le CRM devient la mémoire commerciale de votre activité.",
    navigateTo: "/crm",
    placement: "right",
  },
  {
    id: "page-crm",
    target: '[data-tour-step="crm-tabs"]',
    title: "Liste de contacts et Machine CRM",
    description:
      "Consultez tous vos contacts en vue liste, ou importez un ancien fichier avec la Machine CRM pour réactiver vos contacts dormants.",
    navigateTo: "/crm",
    placement: "bottom",
  },
  {
    id: "sidebar-messages",
    target: '[data-tour-step="nav-messages"]',
    title: "Messagerie centralisée",
    description:
      "WhatsApp et email sont regroupés dans une seule inbox. Vous gardez la main sur les échanges, pendant que Juliette vous aide à repérer les conversations importantes et vous prépare des réponses.",
    navigateTo: "/",
    placement: "right",
  },
  {
    id: "sidebar-campaigns",
    target: '[data-tour-step="nav-campaigns"]',
    title: "Templates et campagnes automatisées",
    description:
      "Vos templates viennent d'être créés et intégrés à des campagnes automatisées. Elles envoient les bons messages au bon moment : ne vous occupez de rien, Juliette relance vos clients et fait avancer vos opportunités.",
    navigateTo: "/",
    placement: "right",
  },
  {
    id: "sidebar-scraping",
    target: '[data-tour-step="nav-scraping"]',
    title: "Sniper Web",
    description:
      "Tous les matins, recevez 5 annonces immobilières de vendeurs particuliers sur votre zone de prospection, avec géolocalisation, DPE, historique des prix, photos et lien de l'annonce.",
    navigateTo: "/",
    placement: "right",
  },
  {
    id: "sidebar-referral",
    target: '[data-tour-step="nav-referral"]',
    title: "Ne ratez plus aucune recommandation",
    description:
      "Quand quelqu'un vous dit « je connais une personne qui vend », ne laissez plus l'opportunité disparaître. Envoyez-lui un lien dédié, il remplit les coordonnées, et la recommandation arrive directement dans Systeme1-immo.",
    navigateTo: "/",
    placement: "right",
  },
  {
    id: "cockpit",
    target: null,
    title: "Votre cockpit est prêt",
    description:
      "Vous pouvez maintenant partir du briefing, prospecter sur le terrain, partager vos documents, suivre vos leads et activer vos relances. Systeme1-immo est conçu pour transformer l'intention en action.",
    navigateTo: "/",
    placement: "center",
  },
  {
    id: "juliette-final",
    target: null,
    title: "Et surtout : Juliette ne vous lâche jamais",
    description:
      "C'est le cœur de Systeme1-immo. Juliette rédige vos relances email et WhatsApp, repère les leads chauds et les rendez-vous à ne pas manquer, prépare votre briefing du matin, met à jour vos fiches après chaque échange et connaît toute votre activité. Posez-lui la moindre question, à l'écrit ou à la voix : « Qui relancer aujourd'hui ? », « Prépare un message pour M. Martin », « Où en est ce dossier ? ». Elle vous répond et passe à l'action — n'hésitez jamais à la solliciter.",
    placement: "center",
    ctaLabel: "Commencer",
  },
];
